<template>
  <div class="rights">

    <div class="rights-table">
      <div>
        权益名称
      </div>
      <div>
        总数
      </div>
      <div>
        已使用
      </div>
      <template v-for="(column, index) in rightsList">
        <div :key="index">
          {{ column.right_name }}
        </div>
        <div :key="index">
          {{ column.total_count }}
        </div>
        <div :key="index">
          {{ column.used_count }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import workService from "@/apis/work/index.js";
import leXiang from "@/apis/leXiang/index.js";

export default {
  data() {
    return {
      rightsList: [],
    };
  },
  created() {
    // this.rightsByIdNo();
    this.fangaixianLabelStatusSearch();
  },
  methods: {
    fangaixianLabelStatusSearch() {
      const params = {
        work_id: this.$route.query.id,
      };
      leXiang.fangaixianLabelStatusSearch(params).then((res) => {
        this.rightsList = res;
        console.log(res);
      });
    },
    rightsByIdNo() {
      const query = this.$route.query;
      const params = {
        id_type: query.id_type,
        id_no: query.id_no,
      };
      workService.rightsByIdNo(params).then((res) => {
        this.rightsList = res;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.rights {
  padding: 0 20px;
  overflow-y: scroll;
  height: 100%;
}
.rights-item {
  margin: 20px 0;
  background-color: black;
  box-sizing: border-box;
  border: 1px solid black;
  overflow: hidden;
}
.rights-table {
  display: grid;
  grid-template-columns: 50% 25% 25%;
  text-align: center;
  grid-row-gap: 1px;
  grid-column-gap: 1px;

  div {
    background-color: #fff;
    padding: 5px 10px;
  }
}
</style>